import React, { FC, useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ExamCard from "./ExamCard";
import { UserContext } from "../../context/UserContext";
import OfflineResultUploadModal from "./OfflineResultUploadModal";
import useUserStore from "../../stores/useUserStores";
type ExamInformationSectionProps = {
  tests: Array<any>;
};
const ExamInformationSection: FC<ExamInformationSectionProps> = ({
  tests,
}): JSX.Element => {
  const {
    token,
    setLoading,
    loading,
    setOfflineExamLineInformation,
    offlineExamInformation,
    isResultIsUploaded,
    isResultUploadedForOfflineCentre,
    endTimeOfExams,
    setEndTimeOfExams,
  } = useUserStore();
  const [currExam, setCurrExam] = useState<string>("");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrExam(newValue);
  };
  useEffect(() => {
    if (tests.length > 0) {
      setCurrExam(String(tests[0].id));
    }
  }, [tests]);
  return (
    <div className="bg-white rounded shadow-lg p-4 px-4  flex flex-col mt-4 py-7 ">
      {tests.find((self) => String(self.id) === currExam) &&
      tests.find((self) => String(self.id) === currExam).end_of_exam &&
      new Date(
        tests.find((self) => String(self.id) === currExam).end_of_exam
      ).getTime() <= new Date().getTime() &&
      tests.find((self) => String(self.id) === currExam)?.status ===
        "ACTIVE" ? (
        <OfflineResultUploadModal />
      ) : (
        <></>
      )}

      <TabContext value={currExam}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            {tests.map((self) => (
              <Tab
                label={self.title}
                value={`${self.id}`}
                key={self.id}
                sx={{ fontSize: "12px" }}
              />
            ))}
          </TabList>
        </Box>
        {tests.map((self) => (
          <TabPanel value={`${self.id}`} key={self.id}>
            <ExamCard currTest={self} />
          </TabPanel>
        ))}
      </TabContext>

      {/* <div className="mb-3">
            <Box
              className="border-b-2"
              sx={{
                bgcolor: "background.paper",
              }}
            >
              <Tabs
                value={tab}
                onChange={(event: any, newValue: any) => setTab(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                {Subjectlist.map((item: any, key: number) => (
                  <Tab label={item.domain_value} key={key} />
                ))}
              </Tabs>
            </Box>
          </div> */}
    </div>
  );
};

export default ExamInformationSection;
